// src/Pages/ContentApprovals/actionCenterInboxFlag.ts
//
// Gate for the single-Inbox Action Center (POLICY_ACTION_CENTER.md, epic
// DEV-1201).
//
// CUT OVER 2026-06-02: the unified Inbox is now the DEFAULT interface — no
// env var or localStorage opt-in needed. `ContentApprovalsPage` renders the
// Inbox everywhere. A kill-switch is retained for dev fallback only: set the
// env var OR the localStorage key to the string "false" to temporarily
// restore the legacy four-tab IA. The legacy tab code still lives in
// ContentApprovalsPage (now unreachable by default) pending a cleanup ticket.

const LS_KEY = "l4e_action_center_inbox";

export const isActionCenterInboxEnabled = (): boolean => {
  // Explicit OFF kill-switch (env or per-browser). Anything else → ON.
  const viteFlag = (import.meta as any)?.env?.VITE_ACTION_CENTER_INBOX_ENABLED;
  if (viteFlag === false || viteFlag === "false") return false;
  if (
    typeof process !== "undefined" &&
    process.env?.VITE_ACTION_CENTER_INBOX_ENABLED === "false"
  ) {
    return false;
  }
  try {
    if (typeof window !== "undefined" && window.localStorage?.getItem(LS_KEY) === "false") {
      return false;
    }
  } catch {
    /* localStorage may be unavailable (Safari private mode); ignore */
  }
  return true;
};

/** Dev fallback: set the per-browser kill-switch to restore the legacy tabs. */
export const setActionCenterInboxOverride = (on: boolean): void => {
  try {
    if (on) window.localStorage.removeItem(LS_KEY); // on = default
    else window.localStorage.setItem(LS_KEY, "false"); // off = legacy tabs
  } catch {
    /* ignore */
  }
};
